import PropTypes from 'prop-types';

import {
  propTypeFontStyle,
  propTypeFontWight,
  propTypeTextDecoration,
  propTypeTextTransform,
} from './basic';

const propTypeStyleLabel = PropTypes.shape({
  color: PropTypes.string,
  fontSize: PropTypes.number,
  fontStyle: propTypeFontStyle,
  fontWight: propTypeFontWight,
  textDecoration: propTypeTextDecoration,
  textTransform: propTypeTextTransform,
});

export default propTypeStyleLabel;
